module.exports = [{
      plugin: require('../../pur-spec/gatsby-site/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Elewacje — szablon","short_name":"Elewacje","start_url":"/","background_color":"#ffffff","theme_color":"#004aad","display":"minimal-ui","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2edc35e07c4c96ad5be8e1357b71c06d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../pur-spec/gatsby-site/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
